import React, { useEffect } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import PrivateRoute from "./routing/PrivateRoute";
import { Provider } from "react-redux";
import store from "./store";
import firebase from "./fire";

import Login from "./components/pages/Login";
import withTracker from "./withTracker";

import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import "./App.css";
import "./animations.css";
// Layout Types

import { DefaultLayout, HomeLayout } from "./layouts";

// Route Views
import BlogOverview from "./views/BlogOverview";
import UserProfileLite from "./views/UserProfileLite";
import Errors from "./views/Errors";

import Profile from "./components/pages/Profile";

import PrivateUserRoute from "./routing/PrivateUserRoute";
import Videos from "./views/videos/VideoView";
import AdsListing from "./views/ads/AdsListing";

import CreateVideo from "./views/videos/CreateVideo";
import CreateAds from "./views/ads/CreateAds";
import EditAds from "./views/ads/EditAds";

// if (localStorage.token) {
//   setAuthToken(localStorage.token);
// }
const App = () => {
  // useEffect(() => {
  //   store.dispatch(loadUser());
  //   firebase.auth().onAuthStateChanged(user => {
  //     if(!user){
  //       console.log('user logged out')
  //     }
  //   })
  // }, []);

  return (
    <Provider store={store}>
      <Router>
        {/* basename={process.env.REACT_APP_BASENAME || ""} */}
        <div>
          <Route path="/" exact component={Login} />
          <Route path="/login" exact component={Login} />
          {/* <PrivateUserRoute path="/profile" exact component={Profile} /> */}
          <PrivateRoute
            path="/dashboard"
            exact
            component={withTracker((props) => {
              return (
                <DefaultLayout {...props}>
                  <BlogOverview {...props} />
                </DefaultLayout>
              );
            })}
          />
          <PrivateRoute
            path="/videos"
            exact
            component={withTracker((props) => {
              return (
                <DefaultLayout {...props}>
                  <Videos {...props} />
                </DefaultLayout>
              );
            })}
          />
          <PrivateRoute
            path="/ads"
            exact
            component={withTracker((props) => {
              return (
                <DefaultLayout {...props}>
                  <AdsListing {...props} />
                </DefaultLayout>
              );
            })}
          />
          <PrivateRoute
            path="/create-video"
            exact
            component={withTracker((props) => {
              return (
                <DefaultLayout {...props}>
                  <CreateVideo {...props} />
                </DefaultLayout>
              );
            })}
          />

          <PrivateRoute
            path="/create-ads"
            exact
            component={withTracker((props) => {
              return (
                <DefaultLayout {...props}>
                  <CreateAds {...props} />
                </DefaultLayout>
              );
            })}
          />

          <PrivateRoute
            path="/edit-ads"
            exact
            component={withTracker((props) => {
              return (
                <DefaultLayout {...props}>
                  <EditAds {...props} />
                </DefaultLayout>
              );
            })}
          />

          <PrivateRoute
            path="/errors"
            exact
            component={withTracker((props) => {
              return (
                <DefaultLayout {...props}>
                  <Errors {...props} />
                </DefaultLayout>
              );
            })}
          />

          <PrivateRoute
            path="/admins/profile"
            exact
            component={withTracker((props) => {
              return (
                <DefaultLayout {...props}>
                  <UserProfileLite {...props} />
                </DefaultLayout>
              );
            })}
          />
        </div>
      </Router>
    </Provider>
  );
};
export default App;
